export default __webpack_public_path__ + "static/media/email-aux-dark.02e797f1.svg";